import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { autoComplete } from "../../services/pappers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import autoCompleteZipCode from "../../services/zipCodes";
import { userProfileValidationSchema } from "../../validationSchemas/utilisateur.validation";

const ValidatedMyAccountForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{
        email: props.email,
        firstName: props.firstName,
        lastName: props.lastName,
        phone: props.phone
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Adresse E-mail nécessaire";
        } else if (!EmailValidator.validate(values.email)) {
          errors.email = "Adresse E-mail invalide";
        }

        const passwordRegex = /(?=.*[0-9])/;
        if (!values.password) {
          errors.password = "Mot de passe nécessaire pour toute modification";
        } else if (values.password.length < 2) {
          errors.password =
            "Votre mot de passe doit faire au moins 2 caractères de long.";
        } else if (!passwordRegex.test(values.password)) {
          errors.password =
            "Votre mot de passe doit contenir au moins un caractère spécial.";
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={userProfileValidationSchema}
    >
      {props => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        return (
          <form name="register" onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <label htmlFor="lastName" className="form-label">
                  Nom
                </label>
                <input
                  name="lastName"
                  type="text"
                  className={`form-control ${errors.lastName &&
                    touched.lastName &&
                    "is-invalid"}`}
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.lastName && touched.lastName && (
                  <div className="invalid-feedback">{errors.lastName}</div>
                )}
              </Col>{" "}
              <Col xs={12} md={6}>
                <label htmlFor="lastName" className="form-label">
                  Prénom
                </label>
                <input
                  name="firstName"
                  type="text"
                  className={`form-control ${errors.firstName &&
                    touched.firstName &&
                    "is-invalid"}`}
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.firstName && touched.firstName && (
                  <div className="invalid-feedback">{errors.firstName}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <label htmlFor="email" className="form-label">
                  Adresse E-Mail
                </label>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.email && touched.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="phone" className="form-label">
                  Téléphone
                </label>
                <input
                  name="phone"
                  type="tel"
                  className={`form-control ${errors.phone &&
                    touched.phone &&
                    "is-invalid"}`}
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.phone && touched.phone && (
                  <div className="invalid-feedback">{errors.phone}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <label htmlFor="password" className="form-label">
                  Mot de passe
                </label>{" "}
                <span className="text-muted"></span>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${errors.password &&
                    touched.password &&
                    "is-invalid"}`}
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.password && touched.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="passwordConfirmation" className="form-label">
                  Mot de passe (confirmation)
                </label>
                <input
                  name="passwordConfirmation"
                  type="password"
                  className={`form-control ${errors.passwordConfirmation &&
                    touched.passwordConfirmation &&
                    "is-invalid"}`}
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.passwordConfirmation &&
                  touched.passwordConfirmation && (
                    <div className="invalid-feedback">
                      {errors.passwordConfirmation}
                    </div>
                  )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Mettre à jour
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default ValidatedMyAccountForm;
